module.exports = __webpack_public_path__ + "img/Taotao Wang.2d01c976.jpg";